import { render, staticRenderFns } from "./GeodesiaRecordForm.vue?vue&type=template&id=b87f8eaa&scoped=true"
import script from "./GeodesiaRecordForm.vue?vue&type=script&lang=js"
export * from "./GeodesiaRecordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87f8eaa",
  null
  
)

export default component.exports